import { DiagramMenuCheckbox } from '@/components/diagrams/components/DiagramStylePickers/DiagramOptionPicker';

/** The tile text that a tile setting shows or hides. */
export type DiagramTileTextField = 'notes' | 'footer';

/** The menu order of the Figma handoff: the footer, then the notes. */
const FIELD_LABEL: Record<DiagramTileTextField, string> = {
  footer: 'Show footer',
  notes: 'Show notes',
};

export interface DiagramTileSettingsItemsProps {
  /** True when every tile in scope shows the field. */
  shows: Record<DiagramTileTextField, boolean>;
  onChange: (field: DiagramTileTextField, show: boolean) => void;
}

/**
 * The menu checkboxes that show or hide the footer and the notes of tiles. A
 * checked box shows that every tile in scope shows the field. A click on a
 * checked box hides the field. Otherwise it shows the field.
 */
export function DiagramTileSettingsItems({
  shows,
  onChange,
}: DiagramTileSettingsItemsProps) {
  return (
    <>
      {(Object.keys(FIELD_LABEL) as DiagramTileTextField[]).map((field) => (
        <DiagramMenuCheckbox
          key={field}
          label={FIELD_LABEL[field]}
          checked={shows[field]}
          onChange={(show) => onChange(field, show)}
        />
      ))}
    </>
  );
}
